import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'
import { HeadingTextRebrandResult } from 'src/components/layouts/Page/SanityContentPage/types'
import { CmsCtaButtonRebrand } from 'src/components/molecules/CmsCtaButtonRebrand'
import { Text } from 'src/components/molecules/sanity/Content'

const BACKGROUND_CLASS: Record<
  NonNullable<HeadingTextRebrandResult['backgroundColor']>,
  string
> = {
  lavenderPale: 'bg-lavenderPale',
  limePale: 'bg-limePale',
  linen: 'bg-linen'
}

// Vertical padding values mirror SectionSpacerRebrand's size scale.
const PADDING_TOP_CLASS: Record<
  NonNullable<HeadingTextRebrandResult['paddingTop']>,
  string
> = {
  small: 'pt-2 md:pt-4',
  medium: 'pt-3 md:pt-6',
  large: 'pt-6 md:pt-12',
  xLarge: 'pt-10 md:pt-20'
}

const PADDING_BOTTOM_CLASS: Record<
  NonNullable<HeadingTextRebrandResult['paddingBottom']>,
  string
> = {
  small: 'pb-2 md:pb-4',
  medium: 'pb-3 md:pb-6',
  large: 'pb-6 md:pb-12',
  xLarge: 'pb-10 md:pb-20'
}

export const HeadingTextSectionRebrand = ({
  heading,
  text,
  buttons,
  backgroundColor,
  paddingTop,
  paddingBottom
}: HeadingTextRebrandResult) => {
  const outerClass = [
    backgroundColor && BACKGROUND_CLASS[backgroundColor],
    paddingTop && PADDING_TOP_CLASS[paddingTop],
    paddingBottom && PADDING_BOTTOM_CLASS[paddingBottom]
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={outerClass}>
      <div className='container mx-auto flex flex-col gap-4 px-4 lg:px-20'>
        {heading && (
          <TypographyRebrand variant='h2' color='forestDeep'>
            <Text
              components={{
                block: ({ children }) => (
                  <span className='block'>{children}</span>
                )
              }}
              value={heading}
            />
          </TypographyRebrand>
        )}
        {text && (
          <div className='[&_a]:text-forestDeep! [&_a]:underline [&_a]:hover:text-forestDeepHover!'>
            <TypographyRebrand variant='introduction' color='forestDeep'>
              <Text
                components={{
                  block: ({ children }) => (
                    <p className='mb-4 last:mb-0'>{children}</p>
                  ),
                  list: {
                    bullet: ({ children }) => (
                      <ul className='mb-4 list-disc pl-6 last:mb-0'>
                        {children}
                      </ul>
                    )
                  },
                  listItem: {
                    bullet: ({ children }) => (
                      <li className='mb-1'>{children}</li>
                    )
                  }
                }}
                value={text}
              />
            </TypographyRebrand>
          </div>
        )}
        {buttons && buttons.length > 0 && (
          <div className='flex flex-row flex-wrap gap-4'>
            {buttons.map((button, idx) => (
              <CmsCtaButtonRebrand key={`htr-btn-${idx}`} {...button} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default HeadingTextSectionRebrand
